export default {
  selected: 'Sélectionné',
  deselect_all_selected_options:
    'Désélectionner toutes les options sélectionnées',
  expanded: 'Déplié',
  collect: 'Collecter',
  no_options_available: 'Aucune option disponible',
  required: 'Requis',
  input_clear_aria_label: 'Effacer la saisie',
  input_show_hide_password_aria_label: 'Afficher ou masquer le mot de passe',
  input_increment_aria_label: 'Augmenter la valeur',
  input_decrement_aria_label: 'Diminuer la valeur',
  english: 'Anglais',
  chinese: 'Chinois',
  portuguese: 'Portugais',
  spanish: 'Espagnol',
  dutch: 'Néerlandais',
  french: 'Français',
  german: 'Allemand',
  russian: 'Russe',
  ukrainian: 'Ukrainien',
  korean: 'Coréen',
  italian: 'Italien',
  czech: 'Tchèque',
  access_your_account: 'Accéder à votre compte',
  use_your_company_credentials_to_get_started:
    "Utilisez vos identifiants d'entreprise pour commencer",
  internal_user_login: 'Utilisateur Interne (SSO)',
  external_user_login: 'Utilisateur Externe',
  or: 'ou',
  keycloak_init_error:
    "Impossible de se connecter au serveur d'authentification. Vérifiez votre connexion réseau et réessayez.",
  this_link_has_expired: 'Ce lien a expiré',
  login: 'Connexion',
  sample_no_production_date_message:
    'La date de fabrication doit être sélectionnée',
  free_comment: 'Commentaire libre',
  save_comments: 'Enregistrer & Fermer',
  round_list_rounds: 'Rondes',
  round_edit_round: 'Modifier la Ronde',
  round_new_round: 'Nouvelle Ronde',
  round_remove_round: 'Êtes-vous sûr de vouloir supprimer la Ronde?',
  round_schedule: 'Planification',
  round_tasters_unselect_all: 'Désélectionner tous les dégustateurs',
  round_tasters_select_all: 'Sélectionner tous les dégustateurs',
  round_close: 'Fermer la Ronde',
  round_close_message: 'Êtes-vous sûr de vouloir terminer cette ronde?',
  round_create_site_message:
    'Vous créez une ronde qui ne provient pas de votre site!',
  round_closed_message: 'Les rondes fermées ne peuvent pas être modifiées',
  round_status_created: 'Créée',
  round_status_samples: 'Échantillons',
  round_status_scheduled: 'Programmée',
  round_status_tasters: 'Dégustateurs',
  round_status_in_progress: 'En cours',
  round_status_finished: 'Terminée',
  round_status_closed: 'Fermée',
  round_schedule_start_finish_date:
    'La date de début ne peut pas être postérieure à la date de fin',
  round_schedule_finish_date_no_start_date:
    "Vous devez d'abord sélectionner une date de début",
  round_disabled_discussion_tooltip:
    "Vous ne pouvez pas accéder à une discussion d'une ronde inachevée.",
  round_up_down_maintenance_tooltip:
    'Cette fonctionnalité est en cours de maintenance et est temporairement indisponible',
  round_delete_other_users_rounds:
    "Vous n'êtes pas autorisé à supprimer une ronde que vous n'avez pas créée",
  round_randomize_samples_order_button: 'Mélanger',
  round_block_results_tooltip:
    "Bloquez les résultats de cette ronde pour empêcher leur téléchargement dans l'écran des rapports. Si le bouton est désactivé, vous n'avez pas le privilège de bloquer les résultats des rondes depuis cet emplacement.",
  round_block_results_confirm:
    'Êtes-vous sûr de vouloir bloquer/débloquer les résultats de la ronde?',
  round_block_results_no_privilege:
    "Vous n'avez pas le privilège de bloquer/débloquer les résultats des rondes depuis cet emplacement.",
  sample_list_samples: 'Échantillons',
  sample_edit_sample: "Modifier l'échantillon",
  sample_new_sample: 'Nouvel échantillon',
  sample_remove_sample: "Supprimer l'échantillon",
  sample_upload_document: 'Télécharger des documents',
  sample_download_documents: 'Documents des échantillons',
  sample_tasted_dates: 'Date de Dégustation',
  sample_upload_message:
    'Pour charger plusieurs documents, ajoutez-les dans un fichier .zip',
  sample_not_for_kpi: 'Pas pour KPI',
  sample_package: 'Emballage',
  sample_volume: 'Volume',
  sample_production_date: 'Date de production',
  sample_expire_date: 'Date de péremption',
  sample_trial_identifier: "Identifiant d'essai",
  sample_project_name: 'Nom du projet',
  sample_linked: 'Lié à une ronde',
  sample_expire_bigger_than_production:
    "La date de production ne peut pas être supérieure à la date d'expiration",
  sample_no_site_message:
    'Il est obligatoire de sélectionner une Zone, un Pays et un Site pour créer un échantillon',
  sample_no_brand_message: 'Il est obligatoire de sélectionner une Marque',
  sample_duplicated_kpi_message:
    'Il existe déjà un KPI pour le mois, la marque et le site que vous avez sélectionnés et vous ne pourrez pas enregistrer',
  sample_duplicated_kpi_message_quarter:
    'Il existe déjà un indicateur clé de performance (KPI) pour le trimestre, la marque et le site que vous avez sélectionnés. Vous ne pourrez donc pas enregistrer vos modifications.',
  sample_duplicated_project_message:
    "Il existe déjà un échantillon avec ce nom de projet et cet identifiant d'essai pour ce site et cette marque, et vous ne pourrez pas l'enregistrer",
  sample_project_no_name_or_trial:
    "Le nom du projet et l'identifiant d'essai sont obligatoires lors de la création d'un échantillon de type projet",
  sample_production_to_project_confirm_message:
    'Vous changez le type de cet échantillon de PRODUCTION à PROJET. Souhaitez-vous continuer?',
  sample_project_to_production_confirm_message:
    'Vous changez le type de cet échantillon de PROJET à PRODUCTION. Souhaitez-vous continuer?',
  sample_no_volume_message:
    "L'emballage et le volume sont obligatoires lors de la création/modification d'un échantillon.",
  sample_id_code_message: 'Veuillez inclure le numéro de lot complet',
  sample_show_all_samples_hint:
    "Affichage des échantillons créés jusqu'à un an à partir d'aujourd'hui. Cochez cette case si vous souhaitez également voir des échantillons plus anciens",
  sample_show_all_samples_label: 'Afficher tous les échantillons',
  package_duplicate: 'Il existe déjà un emballage avec ce nom',
  common_production: 'Production',
  day: 'jour',
  common_project: 'Projet',
  group_list_groups: 'Groupes',
  group_edit_group: 'Modifier le groupe',
  group_new_group: 'Nouveau groupe',
  group_remove_group: 'Supprimer le groupe',
  group_close_modal: 'Fermer',
  group_duplicated_user: 'Cet utilisateur a déjà été ajouté à ce groupe!',
  group_no_name_message: 'Il est nécessaire de saisir un nom de groupe',
  group_no_zone_message: 'Il est nécessaire de sélectionner une zone',
  group_no_users_message:
    'Il est nécessaire de sélectionner au moins un dégustateur',
  family_list_families: 'Styles',
  family_edit_family: 'Modifier le style',
  family_new_family: 'Nouveau style',
  family_remove_family: 'Supprimer le style',
  families_page_description:
    'Gérez tous les styles et leurs configurations au même endroit',
  family_new_page_description:
    'Remplissez les informations du style et finalisez la création.',
  family_edit_page_description: 'Modifiez les informations du style.',
  family_save_success: 'Style créé avec succès !',
  family_update_success: 'Style mis à jour avec succès !',
  family_save_failed: "Échec de l'enregistrement du style.",
  family_save_success_desc: 'Vérifiez dans les styles ci-dessous.',
  family_update_success_desc: 'Vérifiez dans les styles ci-dessous.',
  family_save_failed_desc: 'Veuillez réessayer dans un instant.',
  the_name_is_duplicated: 'Ce nom est déjà utilisé.',
  common_style_name: 'Nom du Style',
  common_warning: 'Avertissement',
  cancel_new_family_title: 'Annuler le nouveau style ?',
  cancel_edit_family_title: "Annuler l'édition du style ?",
  cancel_new_family_confirm: 'Annuler le nouveau style',
  cancel_edit_family_confirm: "Annuler l'édition du style",
  family_remove_success: 'Style supprimé avec succès',
  family_remove_failed: 'Échec de la suppression du style',
  family_delete_title: 'Supprimer le style ?',
  family_delete_description:
    'Le style {{name}} sera définitivement supprimé. Êtes-vous sûr de vouloir continuer ?',
  family_delete_success: 'Style supprimé avec succès !',
  family_delete_success_desc: 'Le style a été supprimé.',
  family_delete_failed: 'Échec de la suppression du style.',
  family_delete_failed_desc: 'Veuillez réessayer dans un instant.',
  family_has_no_english_name:
    "Il est obligatoire d'avoir le nom du style en anglais",
  brand_list_brands: 'Marques',
  brand_edit_brand: 'Modifier la marque',
  brand_new_brand: 'Nouvelle marque',
  brand_remove_brand: 'Supprimer la marque',
  brand_profile_picture: 'Charger la photo du profil de bière',
  brand_upload_brand_logo: 'Charger le logo de la marque',
  brand_duplicate: 'Attention : il existe déjà une bière avec ce nom',
  brand_has_no_english_name:
    'Vous devez renseigner un nom de marque et un profil de bière correspondant',
  brand_upload_help_message: 'Fichiers PNG et JPG uniquement',
  brand_has_no_product_type: 'Vous devez sélectionner un type de produit',
  package_list_packages: 'Emballages',
  package_edit_package: "Modifier l'emballage",
  package_new_package: 'Nouvel emballage',
  package_remove_package: "Supprimer l'emballage",
  packages_page_description:
    "Gérez tous les types d'emballages et leurs configurations en un seul endroit.",
  comments_page_description:
    'Gérez tous les attributs et leurs configurations en un seul endroit.',
  comments_new_page_description:
    "Remplissez les informations de l'attribut et terminez la création.",
  comments_edit_page_description:
    "Modifiez les informations de l'attribut et terminez la mise à jour.",
  comment_attribute_name: "Nom de l'attribut de saveur",
  comment_select_category: 'Sélectionnez la catégorie de saveur',
  packages_edit_page_description:
    "Modifiez les informations de l'emballage et terminez la mise à jour.",
  package_successfully_created: 'Emballage créé avec succès !',
  package_successfully_created_desc:
    'Consultez-le dans les emballages ci-dessous.',
  package_successfully_updated: 'Emballage mis à jour avec succès !',
  package_successfully_updated_desc:
    'Consultez-le dans les emballages ci-dessous.',
  packages_new_page_description:
    "Remplissez les informations de l'emballage et terminez la création.",
  package_name: "Nom de l'emballage",
  content_already_exists: 'Le contenu existe déjà.',
  language_english: 'Anglais',
  language_chinese: 'Chinois',
  language_portuguese: 'Portugais',
  language_spanish: 'Espagnol',
  language_dutch: 'Néerlandais',
  language_french: 'Français',
  language_german: 'Allemand',
  language_russian: 'Russe',
  language_ukrainian: 'Ukrainien',
  language_korean: 'Coréen',
  language_italian: 'Italien',
  package_has_no_english_name:
    "Le nom de l'emballage en anglais est obligatoire",
  package_volumes: 'Volumes',
  package_new_volume: 'Nouveau volume',
  package_remove_volume: 'Supprimer le volume',
  degree_list_degrees: 'Intensités',
  degree_edit_degree: "Modifier l'intensité",
  degree_new_degree: 'Nouvelle intensité',
  degree_remove_degree: "Supprimer l'intensité",
  category_list_categories: 'Catégories',
  category_edit_category: 'Modifier la catégorie de saveur',
  category_new_category: 'Nouvelle catégorie de saveur',
  category_remove_category: 'Supprimer la catégorie de saveur',
  comment_list_comments: 'Attributs',
  comment_edit_comment: "Modifier l'attribut de saveur",
  comment_new_comment: 'Nouvel attribut de saveur',
  comment_remove_comment: "Supprimer l'attribut de saveur",
  comment_cancel_new_title: "Annuler la création d'un attribut de saveur ?",
  comment_cancel_edit_title: "Annuler la modification de l'attribut de saveur ?",
  comment_cancel_new_confirm: "Annuler la création de l'attribut de saveur",
  comment_cancel_edit_confirm: "Annuler la modification de l'attribut de saveur",
  comment_successfully_created: 'Attribut de saveur créé avec succès !',
  comment_successfully_created_desc: "Retrouvez-le dans l'attribut ci-dessous.",
  comment_successfully_updated: 'Attribut de saveur mis à jour avec succès !',
  comment_successfully_updated_desc: "Retrouvez-le dans l'attribut ci-dessous.",
  comment_create_failed: "Échec de la création de l'attribut de saveur.",
  comment_update_failed: "Échec de la mise à jour de l'attribut de saveur.",
  comment_failed_desc: 'Veuillez réessayer dans un instant.',
  comment_delete_title: "Supprimer l'attribut ?",
  comment_delete_description:
    "L'attribut {{name}} sera définitivement supprimé. Voulez-vous vraiment continuer ?",
  comment_delete_success: 'Attribut supprimé avec succès !',
  comment_delete_success_desc: "Retrouvez-le dans l'attribut ci-dessous.",
  comment_delete_failed: "Échec de la suppression de l'attribut.",
  comment_delete_failed_desc: 'Veuillez réessayer dans un instant.',
  user_list_users: 'Utilisateurs',
  user_edit_user: "Modifier l'utilisateur",
  user_new_user: 'Nouveau contractant ABI',
  user_export_users: 'Exporter les utilisateurs',
  user_list_profiles: 'Profils',
  user_profile_name: 'Nom du profil',
  user_profile_select: 'Sélectionnez un profil',
  user_profile_remove: 'Supprimer le profil',
  user_profile_save: 'Enregistrer le profil',
  user_remove_user: "Supprimer l'utilisateur",
  user_use_terms: "Conditions d'utilisation acceptées",
  report_list_report: 'Rapports',
  report_start_date: 'Date de début',
  report_end_date: 'Date de fin',
  common_average_key_score: 'Score clé moyen',
  common_privileges: 'Privilèges',
  common_abi_name: 'Nom ABI',
  common_id: 'ID',
  common_ranked: 'Classé',
  common_week: 'Semaine',
  common_weeks: 'Semaines',
  common_days: 'Jours',
  common_category: 'Catégorie de saveur',
  common_category_sample: 'Catégorie',
  common_degree: 'Intensité',
  common_comment: 'Attribut de saveur',
  common_status: 'Statut',
  common_zone: 'Zone',
  common_country: 'Pays',
  common_site: 'Site',
  common_start_date: 'Date de début',
  common_finish_date: 'Date de fin',
  common_round_type: 'Type de test',
  common_type: 'Type',
  common_round: 'Ronde',
  common_round_id: 'ID Ronde',
  common_tasters: 'Dégustateurs',
  common_sample_performance: "Performance de l'échantillon",
  common_taste: 'Goût',
  common_key_taster: 'Dégustateur principal',
  common_sample: 'Échantillon',
  common_samples: 'Échantillons',
  common_sample_type: "Type d'échantillon",
  common_family: 'Style',
  common_brand: 'Marque',
  common_product_type: 'Type de produit',
  common_temperature: 'Température',
  common_storage_times: 'Temps de stockage',
  common_sku: 'SKU',
  common_batch: 'Lot',
  common_kpi_month: 'Mois KPI',
  common_logo: 'Logo',
  common_name: 'Nom',
  common_notes: 'Remarques',
  common_email: 'E-mail',
  common_language: 'Langue',
  common_terms_of_use: "Conditions d'utilisation",
  common_profile: 'Profil',
  common_filter: 'Filtrer les utilisateurs',
  common_download: 'Télécharger',
  download: 'Télécharger',
  common_save: 'Enregistrer',
  common_cancel: 'Annuler',
  cancel_add_taster_title: "Annuler l'ajout du dégustateur ?",
  cancel_add_taster_description:
    'Vous avez déjà sélectionné des dégustateurs. L’annulation supprimera votre sélection. Voulez-vous continuer ?',
  cancel_add_taster_confirm: "Annuler l'ajout du dégustateur",
  cancel_enter_concentration_title: 'Annuler la saisie de la concentration ?',
  cancel_enter_concentration_description:
    'Vous avez saisi une valeur de concentration. L’annulation supprimera la saisie non enregistrée. Voulez-vous continuer ?',
  cancel_enter_concentration_confirm: 'Annuler la saisie de la concentration',
  cancel_new_package_title: 'Annuler le nouvel emballage ?',
  cancel_edit_package_title: "Annuler la modification de l'emballage ?",
  cancel_new_package_confirm: 'Annuler le nouvel emballage',
  cancel_edit_package_confirm: "Annuler la modification de l'emballage",
  common_search_users: 'Rechercher des utilisateurs',
  common_search_group: 'Rechercher un groupe',
  common_search_taster: 'Rechercher un dégustateur',
  common_no_data: 'Aucune donnée à afficher',
  common_edit: 'Modifier',
  no_results_found_for_applied_filters:
    'Aucun résultat trouvé pour les filtres appliqués',
  common_loading: 'Chargement...',
  common_search: 'Rechercher...',
  type_more_characters: 'Tapez encore {{count}} caractère(s)...',
  common_cannot_be_empty: '{{field}} ne peut pas être vide',
  common_select_option: 'Sélectionnez une option...',
  search_placeholder: 'Rechercher...',
  no_search_results: 'Aucun résultat trouvé',
  clear_selection: 'Effacer la sélection',
  common_per_page: 'Lignes par page',
  common_attributes: 'Attributs',
  common_not_started: 'Non démarré',
  common_in_progress: 'En cours',
  common_finished: 'Terminée',
  common_start: 'Début',
  common_detail: 'Voir détails',
  common_delete: 'Supprimer',
  common_position: 'Position',
  common_score: 'Score',
  common_score_scale: 'Échelle de score',
  common_intensity: 'Intensité',
  common_report_not_have_data: "Les rondes sélectionnées n'ont eu aucun vote",
  month_0: 'Janvier',
  month_1: 'Février',
  month_2: 'Mars',
  month_3: 'Avril',
  month_4: 'Mai',
  month_5: 'Juin',
  month_6: 'Juillet',
  month_7: 'Août',
  month_8: 'Septembre',
  month_9: 'Octobre',
  month_10: 'Novembre',
  month_11: 'Décembre',
  dropdown_change_picture: "Changer l'image",
  dropdown_language: 'Langue',
  dropdown_logout: 'Se déconnecter',
  logout_title: 'Déconnexion en cours, veuillez patienter…',
  logout_description: 'Vous vous déconnectez de votre compte.',
  round_not_started: 'Non démarré',
  round_in_progress: 'En cours',
  round_finished: 'Terminée',
  round_filter_start: 'Début',
  tasting_list_rounds: 'Liste des Rondes',
  Menu_tasting_session: 'Session de Dégustation',
  Menu_panel_management: 'Gestion des panneaux',
  Menu_process_management: 'Gestion des processus',
  Menu_product_management: 'Gestion des produits',
  Menu_attributes_management: 'Gestion des attributs',
  tasting_finish_sample: "Finaliser l'échantillon",
  tasting_comments: 'Commentaires',
  tasting_beer_profile: 'Profil de bière',
  tasting_need_select_score_comments:
    'Vous devez définir un score et ajouter au moins un commentaire pour continuer...',
  tasting_finish_taste: 'Terminer la Dégustation',
  tasting_finish_tasting: 'Terminer la Dégustation',
  common_no_comments: 'Sans commentaires',
  previous_comments: 'Commentaires précédents',
  review_submit_title: 'Êtes-vous prêt à soumettre vos résultats?',
  review_submit_description: 'Vous ne pourrez plus modifier ultérieurement',
  review_finish_taste: 'Fin de Dégustation',
  review_warning_sample_title: 'Vous avez des échantillons non dégustés!',
  review_warning_sample_description: 'Voulez-vous continuer sans les goûter?',
  review_warning_sample_review: 'Vérifier',
  review_warning_sample_ok: 'Continuer',
  review_warning_preference_description:
    'Veuillez sélectionner une préférence avant de poursuivre.',
  review_warning_tie_sample_title: 'Vous avez des échantillons à égalité!',
  review_warning_tie_sample_description:
    'Vous ne pouvez pas continuer sans les classer!',
  review_warning_tie_sample_review: 'Révision',
  common_submit: 'Soumettre',
  common_discussion: 'Discussion',
  discussion_order_number: 'Trier par position',
  discussion_order_brewery: 'Trier par brasserie',
  discussion_order_ranking: 'Trier par classement',
  discussion_order_brand: 'Trier par marque',
  discussion_order_score: 'Trier par score',
  discussion_order_key_score: 'Trier par score clé',
  discussion_order_overall_rank: 'Trier par classement général',
  discussion_order_key_rank: 'Trier par rang clé',
  discussion_key_ranking: 'Classement clé',
  discussion_export_error: "Le fichier n'a pas pu être enregistré!",
  discussion_ranking: 'Classement',
  discussion_overall_ranking: 'Classement général',
  common_brewery: 'Brasserie',
  common_trial_identifier: "Identifiant d'essai",
  common_key_score: 'Score clé',
  round_report: 'Exporter vers Excel',
  common_comments: 'Commentaires',
  message_you_cannot_delete_all_comments:
    "Vous ne pouvez pas supprimer tous les commentaires lors de l'édition d'un vote!",
  common_message_empty_profile: 'Nom de profil vide ou blanc non autorisé',
  common_message_out_of_score_range: 'Score hors plage',
  common_duplicate: 'Dupliquer',
  tasting_raw_materials: 'Matières premières',
  tasting_example_sensory_risk:
    "Exemple de risque sensoriel principal : non-conformité à l'arôme attendu",
  tasting_procedure: 'Procédure',
  tasting_sample_preparation: 'Préparation des échantillons',
  tasting_need_select_score: "Vous devez d'abord définir un score!",
  common_category_name: 'Catégorie',
  categories_new_category: 'Nouvelle Catégorie',
  categories_remove_category: 'Voulez-vous vraiment supprimer la Catégorie?',
  categories_list_categories: 'Liste des Catégories',
  categories_list_all_categories: 'Toutes les Catégories',
  common_category_sample_name: 'Échantillons',
  categories_new_category_sample: 'Nouvel Échantillon',
  categories_remove_category_sample:
    "Voulez-vous vraiment supprimer l'échantillon?",
  categories_list_categories_samples: 'Liste des Échantillons',
  common_collection_point: 'Point de collecte',
  common_collection_date: 'Date de collecte',
  common_brew_number: 'Numéro de brassage/MES',
  common_need_explain_nok:
    "Vous ne pouvez pas avoir d'échantillons NOK sans commentaire!",
  common_show_all: 'Afficher tout',
  common_import: 'Importer',
  common_download_template: 'Télécharger le modèle',
  logging_out: 'Déconnexion...',
  common_need_volte_first:
    'Vous ne pouvez pas commenter des échantillons sans avoir voté au préalable!',
  common_yes: 'Oui',
  common_no: 'Non',
  common_only_kpi_sample: 'Échantillon KPI uniquement',
  common_name_template: 'Nom du modèle',
  interaction_log: "Journal d'interaction",
  common_message_zone_empty: 'La zone ne peut pas être vide',
  common_message_country_empty: 'Le pays ne peut pas être vide',
  common_message_site_empty: 'Le site ne peut pas être vide',
  user_new_profile_save: 'Nouveau Profil créé',
  common_in_privileges: 'dans les Privilèges',
  common_download_files: 'Télécharger les fichiers',
  common_view_details: 'Voir les détails',
  common_create_action: 'Créer une action',
  common_action_list: "Liste d'actions",
  common_create_action_description:
    "Remplissez les détails de l'action pour cet échantillon.",
  common_optional: 'facultatif',
  action_deadline: 'Échéance',
  action_description: "Description de l'action",
  action_description_autofill_tooltip: "Description de l'action",
  action_description_autofill_tooltip_description:
    "Généré automatiquement (ID de round / Brasserie / Nom de l'échantillon / Date de production / Utilisateur créateur) + description supplémentaire",
  action_owner: 'Responsable',
  action_meeting: "Réunion du journal d'interaction",
  action_meeting_list: 'Réunion IAL',
  action_producing_site: 'Site producteur',
  action_production_date: 'Date de production',
  action_closed_time: 'Heure de clôture',
  action_meeting_placeholder: 'Veuillez sélectionner une réunion',
  action_status: 'Statut',
  action_status_draft: 'Brouillon',
  action_status_not_started: 'Non commencé',
  action_status_in_progress: 'En cours',
  action_status_delayed: 'Retardé',
  action_status_close: 'Clôturer',

  action_menu_close: 'Clôturer',
  action_cancel: 'Annuler',
  action_add_comment: 'Ajouter un commentaire',
  action_status_canceled: 'Annulé',
  status_record: 'Historique des statuts',
  no_status_record: 'Aucun enregistrement de statut',
  action_type: "Type d'action",
  action_create_user: 'Utilisateur créateur',
  action_create_time: 'Date de création',
  action_creator: 'Créateur',
  action_root_cause: 'Cause racine',
  action_description_placeholder:
    "Veuillez saisir la description de l'action...",
  action_root_cause_placeholder: 'Veuillez saisir la cause racine...',
  action_comment_added: 'Commentaire ajouté avec succès',
  action_comment_add_failed: "Échec de l'ajout du commentaire",
  action_comment_placeholder: 'Entrez votre commentaire...',
  action_status_changed_with_comment: 'Statut modifié avec commentaire',
  required_comment_banner:
    "Puisque vous n'êtes pas le propriétaire de cette action, il est nécessaire de fournir un commentaire au nom du propriétaire.",
  cancel_and_comment: 'Annuler et commenter',
  close_and_comment: 'Fermer et commenter',
  action_edit_action: "Modifier l'action",
  action_owner_placeholder: 'Veuillez sélectionner un responsable',
  action_created_successfully: "L'action a été créée avec succès !",
  action_created_successfully_desc:
    "Consultez l'action créée dans la liste des actions.",
  action_updated_successfully: "L'action a été mise à jour avec succès !",
  action_updated_successfully_desc:
    "Consultez l'action mise à jour dans la liste des actions.",
  action_create_failed:
    "Un problème est survenu lors de la création de l'action",
  action_update_failed:
    "Un problème est survenu lors de la mise à jour de l'action",
  action_save_failed_desc: 'Veuillez réessayer dans un instant.',
  action_deleted_successfully: "L'action a été supprimée avec succès !",
  action_deleted_successfully_desc: 'Consultez-la dans la liste des actions.',
  action_delete_failed:
    "Un problème est survenu lors de la suppression de l'action",
  delete_action_confirm_title: "Supprimer l'action ?",
  delete_action_confirm_description:
    'Cette action sera définitivement supprimée. Êtes-vous sûr de vouloir continuer ?',
  action_added_notification: '[{{userName}}] a ajouté une nouvelle action',
  action_updated_notification: '[{{userName}}] a mis à jour son action',
  action_deleted_notification: '[{{userName}}] a supprimé sa propre action',
  view_action_list: 'Voir la liste des actions',
  pdf_viewer: 'Visionneuse PDF',
  common_all: 'Tout',
  common_continue: 'Continuer',
  common_minimum_score: 'Note minimale',
  common_maximum_score: 'Note maximale',
  common_average_score: 'Score moyen',
  file_upload_fail:
    'Échec du téléchargement du fichier, les erreurs suivantes se sont produites:',
  file_upload_success_with_error:
    "Le téléchargement a réussi, à l'exception des éléments suivants:",
  missing_fields: 'Champs manquants',
  column_error: 'Erreur de colonne',
  common_line: 'Ligne',
  file_no_samples: 'Aucun échantillon trouvé dans le fichier!',
  file_success_upload: 'Fichier téléchargé avec succès!',
  file_duplicated_kpi_project: 'KPI ou projet en double',
  round_schedule_maximum_length:
    'La longueur maximale du nom de la ronde est de 40 caractères.',
  sample_malt_varieties: 'Variétés de malt',
  error_sample_already_in_round: "L'échantillon est déjà dans la ronde",
  malt_varieties_has_no_english_name:
    'Vous devez avoir au moins un nom de variété de malt.',
  malt_varieties_duplicate:
    'Attention : Il existe déjà une variété de malt avec ce nom.',
  malt_varieties_remove: 'Supprimer la variété de malt',
  common_back: 'Retour',
  common_next: 'Suivant',
  malt_varieties_new: 'Nouvelle Variété',
  malt_varieties_edit: 'Modifier la variété',
  malt_varieties_enter_name: 'Entrez le nom',
  malt_varieties_page_description:
    'Gérez toutes les variétés de malt et leurs configurations en un seul endroit.',
  malt_varieties_save_success: 'Variété de malt créée avec succès !',
  malt_varieties_save_success_desc:
    'Vérifiez dans les variétés de malt ci-dessous.',
  malt_varieties_update_success: 'Variété de malt mise à jour avec succès !',
  malt_varieties_update_success_desc:
    'Vérifiez dans les variétés de malt ci-dessous.',
  malt_varieties_delete_title: 'Supprimer la variété de malt ?',
  malt_varieties_delete_description:
    'La variété de malt {{name}} sera définitivement supprimée. Êtes-vous sûr de vouloir continuer ?',
  malt_varieties_delete_success: 'Variété de malt supprimée avec succès !',
  malt_varieties_delete_success_desc:
    'Vérifiez dans les variétés de malt ci-dessous.',
  malt_varieties_delete_failed:
    'Échec de la suppression de la variété de malt.',
  malt_varieties_delete_failed_desc: 'Veuillez réessayer dans un instant.',
  cancel_new_malt_variety_title: 'Annuler la nouvelle variété de malt ?',
  cancel_edit_malt_variety_title: "Annuler l'édition de la variété de malt ?",
  cancel_new_malt_variety_confirm: 'Annuler la nouvelle variété de malt',
  cancel_edit_malt_variety_confirm: "Annuler l'édition de la variété de malt",
  reports_no_dates: 'La date de début et la date de fin sont obligatoires!',
  reports_date_range_message: 'La plage de dates ne peut pas dépasser 1 an',
  round_save_select_site:
    'Pour enregistrer une ronde, vous devez sélectionner un site',
  common_error: "Oups! Une erreur s'est produite. Veuillez réessayer.",
  common_horizontal: 'Horizontal',
  common_unit: 'Unité',
  common_supplier: 'Fournisseur',
  common_flavor: 'Saveur',
  concentration_of_the_base_beer: 'Concentration de la bière de base',
  threshold_aml_method: 'Méthode AML (Méthode Ascendante des Limites)',
  threshold_component_concentration: 'Concentration des composants',
  threshold_sample_different_help: 'Quel échantillon est différent?',
  threshold_each_set_random_order: 'Dans chaque ensemble, ordre aléatoire.',
  threshold_select_base_beer: 'Sélectionner la bière de base',
  common_unity: 'Unité',
  common_finish_session: 'Terminer la session',
  common_filters: 'Filtres',
  review_submit_threshold: 'Voulez-vous vraiment enregistrer?',
  threshold_coder_wrong:
    'Votre code est incorrect. Veuillez entrer le code correct!',
  threshold_didnt_enter_the_code: 'Veuillez entrer votre numéro de siège',
  code: 'Code',
  threshold_samples_required: 'La bière de base et la saveur sont requises',
  threshold_information_helper_sample:
    "Pour enregistrer les informations sur l'échantillon seuil, veuillez cliquer sur le bouton Enregistrer pour conserver vos modifications",
  code_digits: 'Entrez le code à 3 chiffres qui vous a été attribué',
  common_batch_code: 'Code de lot',
  threshold_sample_spiked_with:
    "Dans chaque jeu, choisissez l'échantillon qui a été enrichi avec ",
  threshold_code_already_tasted:
    'Ce code a déjà été dégusté par un autre utilisateur. Entrez un autre code.',
  common_kpi_brands: 'Marques KPI',
  common_year: 'Année',
  common_new_kpi_brand: 'Nouvelle Marque KPI',
  common_action: 'Action',
  kpi_brand_details_title: 'Détails de la KPI Brand',
  kpi_brand_details_description:
    "Consultez les informations complètes et le statut du processus d'approbation.",
  approval_action: "Action d'approbation",
  select_approval_action: "Sélectionnez une action d'approbation",
  reject_reason_title: 'Motif du rejet',
  reject_reason_description: 'Veuillez fournir un motif de rejet.',
  reject_reason_label: 'Motif du rejet',
  reject_reason_placeholder: 'Entrez le motif du rejet...',
  reject_reason_placeholder_site:
    "Entrez le motif du rejet de ce site '{{site}}'...",
  common_confirm: 'Confirmer',
  common_success: 'Succès',
  common_save_failed: "Échec de l'enregistrement. Veuillez réessayer.",
  approval_status_saved_success:
    "Le statut d'approbation a été enregistré avec succès !",
  common_comment_by_category: 'Commentaires par Catégorie',
  common_alphabetic_comment: 'Commentaires alphabétiques',
  common_name_pts_code: 'Code PTS',
  common_name_pts_code_placeholder: 'Code',
  common_name_process_item: 'Article de processus',
  common_name_process_item_placeholder: 'Article',

  kpi_only_numbers_warning:
    'Accepter uniquement les nombres pour les valeurs cibles',
  kpi_max_number_range_warning:
    'Votre valeur cible doit être comprise entre 1 et 9',
  kpi_already_selected_brand_warning:
    'Vous avez sélectionné cette marque, veuillez choisir une autre marque',
  kpi_no_kpi_informed_warning: "Vous n'avez aucune valeur ajoutée",
  kpi_select_year_warning: 'Sélectionnez une année',
  kpi_select_site_warning: 'Sélectionnez un site',
  kpi_existing_configuration_warning:
    'Vous avez des valeurs KPI du même site et de la même année',
  kpi_target_empty_warning: "Une cible d'une de vos marques est vide",
  kpi_saved_successfully: 'Vos valeurs ont été enregistrées avec succès!',
  kpi_submitted_successfully: 'Vos valeurs ont été soumises avec succès!',
  kpi_max_decimals_warning: "Votre valeur cible peut avoir jusqu'à 3 décimales",
  kpi_count_as_kpi_sample: 'Compter comme KPI',
  report_list_report_kpi: 'Rapports KPI',
  report_list_report_taste: 'Rapports de Dégustation',
  select_brand_to_filter: 'Sélectionnez une marque globale!',
  select_year_to_filter: 'Sélectionnez une année!',
  samples_uncheck_kpi_sample_tooltip:
    'Décochez cette case si vous ne voulez pas que cet échantillon soit compté dans le KPI',
  submission_type: 'Type de validation',
  reports_mandatory_zone_filter: 'Sélectionnez au moins une zone',
  custom_scale_title: 'Échelle personnalisée',
  custom_scale_grid_header_score: 'Score',
  custom_scale_grid_header_ageind_scale: 'Échelle de vieillissement forcé',
  the_value_cannot_be_null: 'La valeur ne peut pas être vide!',
  unique_id: 'Identifie de manière unique',
  reports_mandatory_test_type: "Sélectionnez le type d'essai.",
  report_filter_rounds_description:
    'Vous devez sélectionner les champs obligatoires pour charger les options des tours.',
  round_reports_month_warning:
    'La période entre la date de début et la date de fin doit être de 6 mois maximum.',
  zone_can_not_empty: 'La zone ne peut pas être vide',
  error_loading_data:
    'Erreur lors du chargement des données. Veuillez vérifier votre connexion et recharger.',
  beer_batch: 'Lot de bière',
  list_of_beers: 'Liste des bières',
  random: 'Aléatoire',
  preview: 'Aperçu',
  select_the_flavor: 'Sélectionnez la saveur',
  flavor_threshold: 'Seuil de perception des saveurs',
  input_digital_number: "Numéro numérique d'entrée",
  concentration: 'Concentration',
  flavor_order: 'Ordre des saveurs',
  last: 'Dernier',
  tasting: 'Dégustation',
  tasting_page_description:
    "Effectuez une évaluation de dégustation d'échantillons et discutez du résultat.",
  confirmation: 'Confirmation',
  do_you_confirm_the_evaluation_of_this_sample:
    "Confirmez-vous l'évaluation de cet échantillon ?",
  confirm: 'Confirmer',
  evaluate: 'Évaluer',
  correct_answer: 'Bonne réponse',
  threshold: 'Seuil de perception',
  let_a_comment_about_the_tasting: 'Laisser un commentaire sur la Dégustation',
  send: 'Envoyer',
  right_now: "à l'heure actuelle",
  minute_ago: 'Il y a une minute',
  hour_ago: 'Une heure avant',
  day_before: 'Le jour précédent',
  year_ago: 'Il y a un an',
  add_a_flavor: 'Ajouter une saveur',
  soft_drinks: 'Boissons non alcoolisées',
  soft_drinks_brand: 'Marque de boissons gazeuses',
  soft_drinks_brand_target: 'Cible de la marque de boissons gazeuses',
  column_options: 'Choix des colonnes',
  configure_table_title: 'Personnaliser les colonnes',
  configure_table: 'Configurer le tableau',
  configure_table_description:
    'Choisissez les colonnes visibles et définissez leur ordre.',
  configure_table_helper:
    'Au moins 2 colonnes doivent être visibles et 4 colonnes au maximum peuvent être fixées.',
  configure_table_fixed_left: 'Fixée à gauche',
  configure_table_scroll_area: 'Zone de défilement',
  configure_table_fixed_right: 'Fixée à droite',
  configure_table_empty_left:
    'Faites glisser une colonne ici pour la fixer à gauche',
  configure_table_empty_right:
    'Faites glisser une colonne ici pour la fixer à droite',
  configure_table_save: 'Enregistrer les modifications',
  configure_table_reset: 'Rétablir les valeurs par défaut',
  configure_table_discard: 'Abandonner les modifications',
  configure_table_show: 'Afficher',
  configure_table_hide: 'Masquer',
  configure_table_min_visible: 'Au moins 2 colonnes doivent rester visibles',
  configure_table_max_fixed: 'Vous pouvez fixer jusqu’à 4 colonnes',
  configure_table_drag: 'Faire glisser pour réorganiser',
  configure_table_dragging: 'Déplacement en cours',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Sélectionnez les colonnes que vous souhaitez voir apparaître.',
  countdown: 'Compte à rebours',
  less_than_five_minutes:
    "Cette séance de Dégustation se terminera dans 5 minutes, si vous avez besoin de continuer, veuillez contacter l'administration pour retarder la date de fin.",
  the_countdown_to_the_evaluation_has_ended:
    'Le compte à rebours pour les commentaires est terminé. Les commentaires ne sont pas disponibles.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Calculez combien de temps vous aurez besoin pour terminer la Dégustation des échantillons',
  only_six_flavors_can_be_added_at_most:
    'Seuls six arômes au maximum peuvent être ajoutés!',
  concentration_of_the_flavor: 'Concentration de saveur',
  input_value: "Valeur d'entrée",
  Concentration_of_the_flavor_is_required:
    "Concentration requise de l'assaisonnement",
  previous_round: 'Cycle précédent',
  next_round: 'Prochain tour',
  the_end_time_is_greater_than_the_current_time:
    "L'heure de fin doit être supérieure à l'heure actuelle, si vous sélectionnez le même jour que le jour en cours, sélectionnez d'abord l'heure et la minute!",
  check_the_answer_at_the_end_of_the_countdown:
    "Le compte à rebours n'est pas terminé. Vous pouvez voir les réponses après le compte à rebours",
  incremental_step: 'Étapes progressives',
  set3_concentration: 'Concentration Set3',
  concentration_increments_between_levels:
    'Augmentation de la concentration entre les niveaux',
  incremental_set3_concentration_required:
    'Nécessite une étape progressive et une concentration de set3',
  sprint: 'Sprint',
  sprint_number_greater_than_zero:
    'Le numéro de sprint doit être supérieur à 0',
  sprint_notes_at_least_one_note:
    'Les notes de sprint doivent avoir au moins une note',
  sprint_patch_notes_success_update:
    'Notes de patch Sprint mises à jour avec succès.',
  sprint_patch_notes_error_update: `Il n'a pas été possible d'enregistrer les notes.`,
  sprint_number: 'Numéro de sprint',
  sprint_patch_notes: 'Notes de mise à jour de sprint',
  note: 'Noter',
  select_all: 'Sélectionner tout',
  please_add_samples_first: "Veuillez d'abord ajouter un échantillon",
  reverse: 'Annuler',
  new_test: 'Nouveau test',
  triangle_test_name: 'Nom du test de triangulation',
  triangle_test: 'Test de triangulation',
  you_can_not_set_three_identical_samples:
    'Vous ne pouvez pas définir les trois mêmes options',
  its_mandatory_to_input_test_name: 'Veuillez remplir le nom du test',
  its_mandatory_to_input_sample_information:
    "Veuillez remplir les informations de l'échantillon",
  attention: 'Attention',
  test_number: 'Numéro de série du test de triangulation',
  you_selected_the: 'Vous avez choisi',
  next_sample: 'Échantillon suivant',
  remove_triangle_test: 'Supprimer ce test',
  you_can_only_select_up_to_five: 'Un maximum de cinq sélections est autorisé',
  test: 'Test',
  confirm_remove: 'Confirmer la suppression du test?',
  reports_mandatory_zone_country_site_filter:
    'Les zones, les pays, les usines sont nécessaires!',
  reports_mandatory_brand_filter: 'Sélectionnez au moins une marque',
  reports_by_producing_site: 'Rapport par site producteur',
  download_label: "Télécharger l'étiquette",
  standard: 'Valeur standard',
  input_test: 'Saisie des résultats',
  detecting: 'Détection...',
  connected: 'Connecté',
  current_taster: 'Dégustateurs actuels',
  alcohol_concentration: "Concentration d'alcool",
  alcohol_result_submit_failed_title:
    "Un problème est survenu lors de l'envoi du résultat",
  alcohol_result_submit_failed_desc: 'Veuillez réessayer dans un instant.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    "Votre taux d'alcoolémie est excessif. S'il vous plaît retester plus tard!",
  alcohol_test_qualified: "Réussir le test d'alcoolémie",
  alcohol_concentration_configuration: 'Configuration de la concentration d’alcool',
  breathalyzer_configuration_description:
    'Configurez la concentration d’alcool pour chaque site et le statut de conduite des utilisateurs.',
  breathalyzer_configuration_save_success_title: 'La configuration de l’éthylomètre a été mise à jour avec succès !',
  breathalyzer_configuration_save_success_description: 'Consultez les configurations mises à jour dans les paramètres ci-dessous.',
  breathalyzer_configuration_save_failed_title: 'Un problème est survenu lors de la mise à jour de la configuration de l’éthylomètre',
  breathalyzer_configuration_save_failed_description: 'Veuillez réessayer dans un instant.',
  cancel_configuration_title: 'Annuler la configuration ? ',
  cancel_configuration_description: 'Vous avez modifié la configuration. L’annulation supprimera vos modifications non enregistrées. Voulez-vous continuer ?',
  cancel_configuration_confirm: 'Annuler la configuration',
  driving_configuration: 'Configuration de la conduite',
  configuration: 'Configuration',
  input_result: 'Saisie des résultats',
  maximum_alcohol_concentration: "Concentration excessive d'alcool",
  breathalyzer: "Détecteur d'alcool",
  breathalyzer_page_description:
    "Gérez tous les résultats de l'éthylomètre et leurs normes de configuration au même endroit.",
  please_input_a_positive_number_up_to_n_decimal_places:
    'Veuillez entrer un nombre positif de {{field}} décimales maximum',
  you_must_input: 'Vous devez entrer',
  driving: 'Conduite',
  test_time: 'Temps de test',
  input_type: "Type d'entrée",
  list_breathalyzer: 'Analyseur expiratoire',
  Manual: 'Manuel',
  auto: 'Automatique',
  Breathalyzer: "Testeur d'alcool",
  you_do_not_have_privilege_to_export_this_report:
    "Vous n'êtes pas autorisé à exporter ce rapport",
  competitor_beer: 'Bières concurrentes',
  split_round: 'Ronde fractionnée',
  reset: 'Réinitialiser',
  how_many_rounds_splitting_do_you_want_to_make:
    'Combien de rondes voulez-vous créer ?',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'Impossible de fractionner un tour fractionné ou en cours',
  hide_sample_details: "Cacher les détails de l'échantillon",
  hide_sample_details_auto_hide:
    'OUI - vous pouvez diviser les échantillons et afficher automatiquement toutes les informations cachées après que tous les échantillons aient été dégustés.',
  hide_sample_details_manual_hide:
    'Manuel - vous ne pouvez pas diviser les échantillons et vous devez désigner un administrateur temporaire pour désactiver ou masquer manuellement la page de discussion.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    "Les données seront cachées aux dégustateurs: brasserie, date de production, marque, variété de malt et ID de l'échantillon",
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split: `Ce tour est sélectionné Manuel, la fonction de division n'est pas disponible, vous pouvez choisir Auto Hide ou No Hide pour diviser.`,
  data_will_be_hidden_for_ok_nok:
    'Toutes les données pertinentes seront cachées aux dégustateurs',
  you_can_not_add_duplicate_attributes:
    "Vous ne pouvez pas ajouter d'attributs en double.",
  Menu: 'Menu',
  link_breathalyzer: 'Connecté',
  not_link_breathalyzer: 'Non connecté',
  breathalyzer_to_link: 'Connecter un analyseur respiratoire',
  breathalyzer_connection_failed_title:
    "Échec de la connexion de l'éthylomètre",
  breathalyzer_connection_failed_desc: 'Actualisez la page, puis réessayez.',
  breathalyzer_can_not_to_link_for_this_browser:
    "La fonctionnalité du testeur d'alcool a été développée pour l'utilisation d'appareils PC sur Google Chrome.",
  reopen: 'Rouvrir',
  round_reopen_message: 'Êtes-vous sûr de vouloir réouvrir la ronde',
  common_production_line: 'Ligne de production',
  common_packaged_beer_data_code: 'Code de données de bière emballée',
  common_masking_process_for_bottles: 'Processus de masquage des bouteilles',
  common_str_number_days_over_aged: 'Jours de dépassement',
  common_over_aged_beer: 'Bière périmée',
  sample_successfully_swapped: 'Échantillon échangé avec succès.',
  scoring: 'Score',
  configure_available_flavors: 'Configurer les saveurs disponibles',
  process_check: 'Inspection du processus',
  new_process_check: 'Nouvelle inspection de processus',
  edit_process_check: 'Modifier la vérification du processus',
  remove_process_check: 'Supprimer la vérification du processus',
  common_package: 'Emballage',
  common_department: 'Département',
  common_shift: 'Quart de travail',
  common_tank: 'Cuves',
  common_oknok: 'OK/NOK',
  common_remark: 'Remarque',
  show_all_process_check: 'Afficher toutes les vérifications de processus',
  show_all_process_check_help_circle:
    "Afficher les données créées dans un demi-an à partir d'aujourd'hui. Cochez cette case si vous avez encore besoin de voir les données créées dans un an à partir d'aujourd'hui",
  the_sample_date_cannot_be_earlier_than_the_current_time:
    "La date d'échantillonnage ne peut pas être antérieure à l'heure actuelle!",
  common_job_position: 'Poste',
  decimal_sep: 'Séparateur décimal',
  is_swapped_to: 'Sont échangés pour',
  review_warning_comment_title: 'Vous avez des échantillons non commentés!',
  continuous_typing: 'Typage continu',
  continuous_typing_tips:
    'Apr?s avoir sélectionné / tapé Intensity, puis tapez attribute.',
  BSSI_Reports: 'Rapports BSSI',
  data_analysis_sip: 'Analyse des données SIP',
  select_the_color: 'Sélectionnez la couleur',
  color: 'Couleur',
  download_document: 'Documents à télécharger',
  Month_of_Discontinued_Production: 'Mois de production interrompue',
  Suspension_List: 'Liste des suspensions',
  New_Suspension: 'Nouvelle suspension',
  new_suspension_page: 'Nouvelle suspension',
  edit_suspension_page: 'Modifier la suspension',
  Brand_name: 'Nom de marque',
  List_Brewery_Production_Suspension: 'Liste des suspensions de production',
  Upload_successfully: 'Fichier téléchargé avec succès',
  training_materials: 'Matériaux de formation',
  Remove_Suspension: 'Retirer la suspension',
  Add_Absence_Reason: "Ajouter une raison d'absence",
  Reason: 'Raison',
  Select_reason: 'Sélectionner une raison',
  You_have_duplicate_absence_dates: "Vous avez des dates d'absence en double",
  Remove_Absence: "Supprimer l'absence",
  Absence_Title:
    "Veuillez sélectionner l'heure et la raison de votre absence à la dégustation. Consultez ou supprimez les entrées dans Motif soumis.",
  Shipping_Site: "Site d'expédition",
  shipping_received: 'Livraison reçue',
  receive_sample_alert: "Êtes-vous sûr d'avoir reçu l'échantillon?",
  receive_uncheck_alert: 'Êtes-vous sûr de vouloir le décocher?',
  all_received: 'Tous reçus',
  not_all_received: 'Pas tous reçus',
  not_for_shipping: "Pas pour l'expédition",
  receive_hint: 'Sélectionnez tous les sites qui recevront cet échantillon',
  absence_reason: "Raison de l'absence",
  Page1: 'Page {{field}}',
  Search: 'Recherche',
  page_total: 'Total',
  start_date: 'Date de début',
  end_date: 'Date de fin',
  ok_for_all: 'OK pour tous',
  its_mandatory_to_select_sample_A_and_sample_B:
    "Il est obligatoire de sélectionner l'échantillon A et l'échantillon B.",
  its_mandatory_to_select_sample_A:
    "Il est obligatoire de sélectionner l'échantillon A.",
  its_mandatory_to_select_sample_B:
    "Il est obligatoire de sélectionner l'échantillon B.",
  triangle_comment: 'Commentaire',
  select_sample: 'Sélectionner un échantillon',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Filtre de date des échantillons, par défaut les 7 derniers jours, exporté vers Excel en fonction de la durée de ce filtre.',
  select_all_flavor: 'Tout sélectionner',
  deselect_all: 'Désélectionner tout',
  email_distribution: 'Destinataires du rapport mensuel',
  new_email_distribution: 'Nouveaux destinataires du rapport mensuel',
  edit_email_distribution: 'Modifier les destinataires du rapport mensuel',
  distribution_type: 'Type de distribution',
  the_score_entered_is_invalid:
    "Le score saisi n'est pas valide. Veuillez vous référer au tableau des scores pour saisir à nouveau votre score.",
  service_now:
    "Cliquez pour créer un ticket d'incident pour signaler un problème et obtenir de l'aide.",
  service_now_tips:
    "Si vous rencontrez un problème ou souhaitez demander de l'aide, vous pouvez le signaler en cliquant ici. Notre équipe de support vous contactera dès que possible.",
  done: 'Terminé',
  changes_you_made_may_not_be_saved:
    'Les modifications que vous avez apportées peuvent ne pas être sauvegardées. Voulez-vous continuer et perdre vos modifications?',
  cannel_auto_save_tips: `Maintenant que les performances de la page de Dégustation se sont améliorées, n'oubliez pas de cliquer sur "terminer l'échantillon" pour enregistrer et soumettre vos résultats de Dégustation.`,
  list_email_page_tips:
    "Ceci est l'instruction sur la façon de configurer l'échantillon KPI correctement, afin de s'assurer que le rapport mensuel de Zone peut refléter l'analyse exacte pour votre Dégustation de Zone MCS",
  list_email_page_helps:
    'Instructions sur la façon de configurer des échantillons KPI pour refléter les données exactes du Bulletin mensuel régional.',
  kpi_instruction: 'Description des KPI',
  group_no_recipients_message: 'Au moins un destinataire est requis.',
  the_current_distribution_type_already_exists:
    'Le type de distribution actuel existe déjà, veuillez le sélectionner à nouveau ou revenir à la liste.',
  distribution_type_message_empty:
    "Le type de distribution n'est pas autorisé à être vide",
  add_samples: 'Ajouter un ou plusieurs échantillons à la série',
  copy_this_sample: `Dupliquer l'échantillon`,
  remove_this_sample: `Supprimer l'échantillon`,
  drag_samples_here: `Glissez les échantillons ici`,
  drop_here: `Déposez ici`,
  multiple_selection_tips: `Vous pouvez sélectionner plusieurs échantillons à la fois pour le même type d'échantillon. Cliquez sur "+" et "-" pour essayer.`,
  all_add_once_tips: `Cliquez sur le bouton "Tout sélectionner" pour ajouter automatiquement un échantillon à chaque type d'échantillon sélectionné.`,
  copy_confirm_tip: `Êtes-vous sûr de vouloir dupliquer l'échantillon ?`,
  user_non_abi_user: 'Nouvel utilisateur temporaire',
  language_of_email_invitation:
    "Langue de l'invitation par courrier électronique",
  add_non_abi_users_to_round:
    "L'utilisateur temporaire recevra une invitation par courriel avec un lien pour assister à la Dégustation en question.",
  change_non_abi_users_to_round:
    'Le dégustateur temporaire que vous avez invité recevra une invitation par courriel avec un lien pour participer à cette Dégustation.',
  guest: 'Invité',
  email_to_all: 'Envoyer un courriel à tous',
  send_email: "Envoyer un courriel d'invitation",
  temporary_non_abi_taster: 'Dégustateur temporaire',
  user_type: "Type d'utilisateur",
  email_invitation_delivery_request_sent:
    "Demande d'invitation envoyée par courriel.",
  incorrect_e_mail_formatting: "Format d'e-mail incorrect",
  all_tasters: 'Tous les dégustateurs',
  tasters: 'Dégustateurs',
  key_tasters: 'Dégustateurs principaux',
  non_key_tasters: 'Dégustateurs non principaux',
  taster_already_started_cannot_change:
    'Le dégustateur a déjà commencé, ne peut pas être modifié',
  temporary: 'Temporaire',
  maximum_number_of_samples_is: `Le nombre maximum d'échantillons est de`,
  sample_added: 'Échantillon ajouté',
  click_to_view_scale_of_flavour_intensities: `Cliquez sur le lien pour voir les échelles d'intensité détaillées`,
  list_next_week_plan: 'Plan de la semaine prochaine',
  common_time_zone: 'Fuseau horaire',
  common_last_response_time: 'Dernière heure de réponse',
  new_week_plan: 'Plan de la semaine suivante',
  invited_week: 'Semaine invitée',
  email_language: `Langue de l'e-mail`,
  save_and_send_email: `Sauvegarder et envoyer l'email`,
  common_start_time: 'Heure de début',
  common_end_time: 'Heure de fin',
  session_name_email_subject: `Nom de la session / Objet de l'e-mail`,
  location: 'Lieu de la session',
  edit_week_plan: 'Modifier le plan de la semaine',
  email_response: 'Réponse par courriel',
  round_remove_plan: 'Êtes-vous certain de vouloir supprimer le plan',
  view_week_plan: 'Voir le plan de la semaine',
  are_you_confirming_to_send_the_confirmation_email: `Confirmez-vous l'envoi de l'email de confirmation`,
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation: `Toutes les 10 minutes, le système mettra à jour la réponse à l'invitation du plan de la semaine suivante`,
  documents_upload_tips:
    'Les téléchargements de fichiers ne prennent en charge que les fichiers {{field}}',
  ignore_submit: 'Ignorer & Envoyer',
  if_count_as_kpi:
    'Si vous comptez comme KPI, cliquez sur le lien pour voir les étiquettes de KPI',
  confirmed_count: 'Nombre confirmé',
  accepted: 'Accepté',
  declined: 'Refusé',
  no_response: 'Pas de réponse',
  reminder_time: 'Heure de rappel',
  are_you_sure_you_want_to_change_the_week_of_invitation: `Êtes-vous sûr de vouloir supprimer l'heure de début et de fin de la session que vous avez sélectionnée et de vouloir passer à une autre semaine sur invitation `,
  apply_to_all_sessions_location_tasters: `Appliquer 'Lieu de la session' et 'Tasters' aux sessions suivantes`,
  mcs_tasting: 'Dégustation MCS',
  qcs_tasting: 'Dégustation QCS',
  mcs_tasting_tips: `Sélectionnez Oui si cette série contient des échantillons MCS/KPI, le système appliquera le code KPI correspondant à la marque de l'échantillon.`,
  round_samples_shuffle_confirm:
    'Êtes-vous sûr de vouloir mélanger les échantillons ?',
  all_count_as_kpi: 'Tous comptent comme KPI',
  msc_tasting_tour_mask: `Le système identifiera automatiquement le code KPI correspondant sur la base de l'échantillon compté avec le bon mois KPI, de sorte que vous n'aurez PAS à diviser différentes marques en un seul tour.`,
  competition: 'Concours',
  copy_link: 'Copier le lien',
  open_link: 'Ouvrir le lien',
  common_download_img: `Télécharger l'image`,
  please_select_taster: 'Veuillez sélectionner un dégustateur',
  user_principal_name: `Nom de l'utilisateur principal`,
  user_status: `Statut de l'utilisateur`,
  termination_date: `Date d'expiration`,
  function_level: 'Niveau de fonction',
  last_update_time: 'Dernière heure de mise à jour',
  system_related: 'Lié au système',
  workday_related: 'Lié à WorkDay',
  employee_id: `ID de l'employé`,
  zitec_project_name: 'Nom du projet',
  applicant: 'Demandeur',
  applicant_date: 'Date de la demande',
  test_method: `Méthode d'essai`,
  liquid_category: 'Catégorie de liquide',
  conditions: 'Conditions opératoires',
  time_points: 'Points temporels',
  execution_date: `Date d'exécution`,
  execution_by_time_points: `Date d'exécution calculée par points temporels`,
  invitation_start_time: `Heure de début de l'invitation`,
  invitation_end_time: `Heure de fin de l'invitation`,
  invitation_reminder: `Rappel d'invitation`,
  application_form: 'Formulaire de candidature',
  application_form_result: 'Résultat du formulaire de candidature',
  upload_result: 'Télécharger le résultat',
  zitec_sessions: 'Sessions ZITEC',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'Nouvelle session ZITEC',
  common_search_applicant: 'Rechercher un candidat',
  history_record: 'Historique',
  common_quarterly: 'Trimestriel',
  common_month: 'Mois',
  kpi_report: 'Rapport KPI',
  kpi_result: 'Fichier Anaplan',
  action_log: 'Journal des actions',
  validate_data: 'Vérification des données',
  push_anaplan_window_open_date: `Pousser la fenêtre Anaplan Date d'ouverture :`,
  unLock_kpi: `Déverrouiller le KPI`,
  lock_kpi: 'Verrouiller KPI',
  locked: 'Verrouillé',
  unlocked: 'Déverrouillé',
  Menu_kpi_lock: 'Verrouillage KPI',
  freshness_kpi_lock: 'Verrouillage Fraîcheur',
  in_profile_kpi_lock: 'Verrouillage In Profile',
  are_you_sure_you_want_to_lock_kpi:
    'Êtes-vous sûr de vouloir verrouiller le KPI pour {{field}}',
  are_you_sure_you_want_to_unlock_kpi: `Êtes-vous sûr de vouloir déverrouiller l'indicateur de performance clé {{field}} `,
  lock_kpi_month_zone:
    'Vos actions sont limitées en raison du verrouillage des échantillons de KPI activés pour un mois et une région donnés. Si vous avez des questions, contactez votre propriétaire régional pour plus de détails sur le verrouillage des données KPI.',
  lock_freshness_kpi_month_zone:
    'Vos actions sont limitées en raison du verrouillage des échantillons de KPI activés pour un trimestre et une région donnés. Si vous avez des questions, contactez votre propriétaire régional pour plus de détails sur le verrouillage des données KPI.',
  submit_timeout: `L'envoi a échoué. Veuillez réessayer plus tard.`,
  anaplan_un_upload_tips: `Veuillez attendre la prochaine fenêtre ouverte d'Anaplan!`,
  anaplan_un_confirm_tips: `Veuillez confirmer vos données KPI pour un mois donné!`,
  confirmed: 'Confirmé',
  confirm_data: 'Confirmer les données',
  flavor_groups: `Groupes d'arômes`,
  compound: 'Composé',
  sit_code_not_exist: `Ce code de siège n'existe pas, veuillez tenir compte du format du code de siège tel que 001, 002.`,
  sit_code_chose: `Ce code de siège a été choisi, veuillez saisir votre code de siège correct.`,
  kpi_lock: 'Verrouillage KPI',
  kpi_confirmation: 'Confirmation des KPI',
  global_kpi_lock: 'Verrouillage KPI Global',
  select_month: 'Sélectionnez un mois',
  need_to_wait_global_lock: 'Vous devez attendre le verrouillage global.',
  monthly_kpi_locked_zones: 'KPI mensuel Zones verrouillées',
  flavor_confirm_save: `Les saveurs non sélectionnées '{{field}}' sont dans les échantillons ajoutés. Si vous confirmez la sauvegarde de la configuration actuelle de la saveur, les échantillons correspondants seront supprimés`,
  temporary_admin: 'Administrateur temporaire',
  unhide_sample_details: `Afficher les détails de l'échantillon`,
  hide_sample: `Cacher l'échantillon`,
  download_report_timeout_error_message: `Timeout d'accès, veuillez vérifier la connexion réseau.`,
  you_can_only_select_up_to: `Vous ne pouvez sélectionner qu'un maximum de {{field}}, veuillez réduire le nombre de choix.`,
  push_anaplan: 'Pousser Anaplan',
  pushed: `Poussé`,
  self_evaluation_report: `Cliquer pour télécharger le rapport d'auto-évaluation`,
  date_range: 'Plage de dates',
  kpi_month_range: 'KPI Plage de mois',
  quick_select: 'Sélection rapide',
  current_month: 'Mois en cours',
  current_year: 'Année en cours',
  a_whole_year: 'Une année entière',
  download_self_evaluation_report: `Télécharger le rapport d'auto-évaluation`,
  select_tasters: 'Sélectionner les dégustateurs',
  create_ticket: 'Créer un ticket',
  sensory_intelligent_platform: 'Plateforme Sensorielle Intelligente - PBI',
  external_links: 'Liens externes',
  evaluation_report: `Rapport d'évaluation`,
  download_evaluation_report: `Télécharger le rapport d'évaluation`,
  taster_type: 'Type de dégustateur',
  taster_evaluation_tip: `Vous pouvez maintenant cliquer ici pour télécharger votre rapport d'auto-évaluation!`,
  admin_evaluation_tip: `Vous pouvez maintenant cliquer ici pour télécharger le rapport d'évaluation des dégustateurs!`,
  kpi_sample: `Échantillon KPI`,
  add_to_download_list: 'Ajouter à la liste de téléchargement',
  to_download_list: 'à télécharger',
  selected_tasters: 'Dégustateurs sélectionnés',
  generation_time: 'Temps de génération',
  start_month: 'Début du mois',
  end_month: 'Fin du mois',
  download_all: 'Télécharger tout',
  new_physchem_tips: `Vous pouvez maintenant cliquer ici pour ajouter les propriétés physico-chimiques de l'échantillon`,
  view_physchem_tips: `Vous pouvez maintenant cliquer ici pour afficher les propriétés physico-chimiques des échantillons du cycle actuel`,
  physchem_disabled_tips: `Impossible d'afficher phychem lorsque les échantillons sont masqués`,
  package_code: `Code de l'emballage`,
  concentration_at_fu: 'Concentration à 1 unité aromatique',
  base_beer: 'Bière de base',
  flavor_intensities_scale: `Échelle d'intensité des arômes`,
  flavor_unit: 'Unité de saveur',
  add_a_sample: 'Ajouter un échantillon',
  common_kpi_quarter: 'KPI Trimestre',
  sample_duplicated_quarter_kpi_message:
    'Il existe déjà un KPI pour le trimestre, la marque et le site que vous avez sélectionnés et vous ne pourrez pas enregistrer.',
  select_quarter: 'Sélectionner le trimestre',
  please_select_kpi_quarter: 'Veuillez sélectionner le trimestre KPI',
  error_fields: `Champs d'erreur`,
  your_answer: 'Votre réponse',
  preference: 'Préférence',
  please_select_preference_group:
    'Vous devez sélectionner vos préférences avant de soumettre votre demande!',
  monthly_report: 'Rapport mensuel',
  draft: 'Brouillon',
  confirm_send: 'Confirmer et envoyer',
  sent_completion: 'Envoi terminé',
  send_draft: 'Envoyer le brouillon',
  send_draft_monthly_report:
    'Envoyez le rapport mensuel à votre adresse e-mail.',
  please_confirm_the_recipients:
    'Veuillez confirmer les destinataires du rapport mensuel.',
  total_recipients: 'Nombre total de destinataires',
  sending: 'Envoi en cours',
  sending_monthly_report_tips1: `Votre demande est en cours de traitement.`,
  sending_monthly_report_tips2: `Veuillez consulter le "Journal des actions" pour connaître le résultat.`,
  configure_upgrade_center: 'Configurer le centre de mise à niveau',
  sprint_content: 'Contenu du sprint',
  release_date: 'Date de publication',
  add_sprint: 'Ajouter un sprint',
  sprint_materials: 'Matériaux du sprint',
  upgrade_center: 'Centre de mise à niveau',
  function: 'Fonction',
  my_evaluation_report: "Mon rapport d'évaluation",
  upgrade_center_remove_sprint_number:
    'Êtes-vous sûr de vouloir supprimer ce numéro de sprint',
  sprint_version_tips: 'Cliquez pour afficher le matériel du sprint.',
  edit_sprint: 'Modifier Sprint',
  new_sprint_tips:
    'Vous pouvez désormais cliquer ici pour consulter les documents relatifs au sprint.',
  production_date_range: 'Période de production',
  preparation: 'Préparation',
  panel: 'Panel',
  session: 'Session',
  product: 'Produit',
  attribute: 'Attribut',
  common_menu_samples: 'Échantillons',
  common_Menu_rounds: 'Rondes',
  common_Menu_groups: 'Groupes',
  common_Menu_suspension_list: 'Suspension',
  common_Menu_planning_week_sessions: 'Sessions de planification hebdomadaire',
  common_Menu_zitec_sessions: 'Sessions ZITEC',
  common_Menu_brands: 'Marques',
  common_Menu_kpi_brands: 'Marques KPI',
  common_Menu_packages: 'Paquets',
  common_Menu_styles: 'Styles',
  common_Menu_malt_variety: 'Variété de malt',
  common_Menu_intensities: 'Intensités',
  common_Menu_categories: 'Catégories',
  common_Menu_attributes: 'Attributs',
  common_Menu_user_management: 'Gestion des utilisateurs',
  common_menu_role_management: 'Gestion des rôles',
  common_Menu_permission_control: 'Contrôle des permissions',
  system: 'Système',
  select_taste_type: 'Sélectionner le type de dégustateur',
  select_round: 'Sélectionner la ronde',
  a_previous_request_is_still_being_processed:
    'Une demande précédente est encore en cours de traitement. Veuillez réessayer plus tard.',
  select_item: 'Sélectionner {{field}}',
  common_new_kpi_brand_button: 'Nouvelle KPI brand',
  common_target: 'Cible',
  common_focus_brands: 'Marques Focus',
  common_strategic_brands: 'Marques Stratégiques',
  kpi_brands_new_page_description:
    'Interface de Création de Nouvelle KPI Brand, avec des fonctions pour remplir les informations de KPI Brand, soumettre et enregistrer.',
  kpi_brands_edit_page_description:
    "Modifier l'interface KPI Brand, avec fonctions pour mettre à jour, soumettre et enregistrer les informations KPI Brand.",
  kpi_brands_edit_page_description_prefix:
    'Afficher et configurer les KPI Brands pour ',
  kpi_brands_page_description:
    'Interface de gestion des KPI Brands, avec fonctions de visualisation, soumission et révision.',
  table_apply: 'Appliquer',
  table_clear: 'Effacer',
  table_search: 'Rechercher',
  table_enter_to_filter: 'Saisir pour filtrer...',
  table_select_to_filter: 'Sélectionner pour filtrer...',
  table_select_all: 'Tout sélectionner',
  table_select_all_aria: 'Sélectionner toutes les lignes',
  table_select_row_aria: 'Sélectionner la ligne',
  table_filter_by: 'Filtrer par',
  table_clear_filters: 'Effacer les filtres',
  table_reset_filters: 'Réinitialiser les filtres',
  table_no_results_for_filters: 'Aucun résultat trouvé pour les filtres appliqués.',
  table_items_selected: 'éléments sélectionnés',
  table_sort: 'Trier',
  table_sort_toggle: 'Cliquez pour basculer le tri',
  table_no_options: 'Aucune option disponible',
  table_reset: 'Réinitialiser',
  table_all: 'Tout',
  table_no_results: 'Aucun résultat trouvé pour les filtres appliqués',
  common_approved_at: 'Approuvé le {{date}}',
  common_rejected_at: 'Rejeté le {{date}}',
  kpi_status_created: 'Créé',
  kpi_status_waiting_for_approval: 'En attente de validation',
  kpi_status_approved: 'Approuvé',
  kpi_status_rejected: 'Rejeté',
  kpi_action_approve: 'Approuver',
  kpi_action_reject: 'Rejeter',
  common_by_user: 'par {{user}}',
  pagination_aria_label_next_page: 'Aller à la page suivante',
  pagination_aria_label_previous_page: 'Aller à la page précédente',
  pagination_aria_label_first_page: 'Aller à la première page',
  pagination_aria_label_last_page: 'Aller à la dernière page',
  pagination_aria_label_input: 'Entrez la page souhaitée, de 1 à {totalItems}',
  pagination_aria_label_items_per_page:
    '{pageSize} éléments par page sélectionnés, cliquez pour modifier',
  pagination_lines_per_page: 'Lignes par page',
  pagination_total_pages: 'sur {totalPages}',
  pagination_total_elements:
    '{firstItem}-{lastItem} sur {totalItems} résultats',
  pagination_no_results: 'Aucun résultat trouvé',
  kpi_brand_successfully_saved: 'KPI brand enregistrée avec succès !',
  kpi_brand_saved_description:
    "Vérifiez-la dans la KPI brand ci-dessous. Il s'agit uniquement d'une sauvegarde temporaire, la soumission pour approbation n'est pas encore terminée.",
  kpi_brand_failed_to_save: "Échec de l'enregistrement de la KPI brand.",
  kpi_brand_save_failed_description: 'Veuillez réessayer dans un moment.',
  kpi_brand_successfully_submitted: 'KPI brand créée avec succès !',
  kpi_brand_submitted_description:
    "Consultez la KPI brand ci-dessous. Veuillez vérifier la progression de l'approbation sur la page de détails ; cette KPI brand ne sera disponible qu'après approbation.",
  kpi_brand_failed_to_submit: 'Échec de la création de la KPI brand.',
  kpi_brand_submit_failed_description: 'Veuillez réessayer dans un moment.',
  flavor_id_discussion: "Discussion sur l'identification des saveurs",
  view_and_discussion_for: 'Consulter et discuter pour',
  common_cup: 'Verre',
  tasters_joined: 'Dégustateurs participants',
  tasters_all_correct: 'Dégustateurs tout correct',
  total_accuracy: 'Précision globale',
  accuracy: 'Précision',
  all_correct: 'Tout correct',
  otherwise: 'Autres',
  result: 'Résultat',
  Key: 'Principal',
  nonkey: 'Non principal',
  common_guest: 'Invité',
  view_correct_answers: 'Voir les bonnes réponses',
  hide_correct_answers: 'Masquer les bonnes réponses',
  change_to_table: 'Passer en tableau',
  change_to_card: 'Passer en cartes',
  not_answered: 'Non répondu',
  actions: 'Actions',
  actions_page_description:
    'Voir toutes les Actions créées par les utilisateurs pendant la session de dégustation.',
  action_created_by: 'Créé par',
  my_actions: 'Mes Actions',
  action_list_info: 'L’action sera créée après la clôture du round.',
  unsaved_changes_warning:
    'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?',
  common_go_back: 'Retour',
  cancel_create_action_title: "Annuler la création de l'action ?",
  cancel_edit_action_title: "Annuler la modification de l'action ?",
  cancel_create_action_confirm: "Annuler la création de l'action",
  cancel_edit_action_confirm: "Annuler la modification de l'action",
  unsaved_changes_description:
    'Vous avez saisi du contenu dans le formulaire. L’annulation supprimera toutes les saisies non enregistrées. Voulez-vous continuer ?',
  unsaved_changes_edit_description:
    'Vous avez modifié le contenu du formulaire. L’annulation supprimera toutes les modifications non enregistrées. Voulez-vous continuer ?',
  action_update_failed_desc: 'Veuillez réessayer dans un instant.',
  action_change_status_successfully: 'Statut modifié !',
  action_change_status_successfully_desc:
    "Le statut de l'action a été modifié en {{status}}.",
  action_change_status_failed: "Le statut n'a pas pu être modifié",
  action_change_status_failed_desc:
    "Le statut de l'action n'a pas pu être modifié. Veuillez réessayer.",
  download_report_success: 'Rapports téléchargés avec succès !',
  download_report_success_desc:
    'Consultez-les dans votre dossier de téléchargements.',
  download_self_evaluation_report_success:
    "Rapport d'auto-évaluation téléchargé avec succès !",
  download_report_failed: 'Échec du téléchargement des rapports.',
  download_report_failed_desc: 'Veuillez réessayer dans quelques instants.',
  evaluation_report_add_success: 'Rapport ajouté avec succès !',
  evaluation_report_add_success_desc:
    'Consultez-le dans le rapport d’évaluation « À télécharger ».',
  evaluation_report_add_failed: 'Échec de l’ajout du rapport.',
  evaluation_report_add_failed_desc:
    'Veuillez réessayer dans quelques instants.',
  add_taster: 'Ajouter un dégustateur',
  alcohol_concentration_result: "Résultat de concentration d'alcool",
  absence_save_success: 'Motif d’absence ajouté avec succès !',
  absence_save_success_desc: 'Consultez-le dans les absences soumises.',
  submitted_absence: 'Absences soumises',
  no_absence_to_show: 'Aucune absence à afficher',
  absence_delete_success: 'Motif d’absence supprimé avec succès !',
  absence_delete_success_desc: 'Consultez la liste mise à jour dans les absences soumises.',
  absence_delete_confirm_title: 'Supprimer l’absence ?',
  absence_delete_confirm_description: 'L’absence [{{start}} - {{finish}}] sera définitivement supprimée. Voulez-vous continuer ?',
  absence_delete_confirm_delete: 'Supprimer',
  absence_save_failed: 'Échec de l’ajout du motif d’absence',
  absence_save_failed_desc: 'Veuillez réessayer dans quelques instants.',
  absence_duplicate_date_desc:
    'Un enregistrement d’absence existe déjà pour la date sélectionnée. Les soumissions en double ne sont pas autorisées.',
  absence_delete_failed: 'Échec de la suppression du motif d’absence',
  absence_delete_failed_desc: 'Veuillez réessayer dans quelques instants.',
  role_management_change_role: 'Changer de rôle',
  role_management_reset_success: 'Autorisations réinitialisées avec succès !',
  role_management_reset_success_desc: 'Les autorisations de ce rôle ont été réinitialisées à la configuration par défaut. Vous pouvez les consulter dans le contrôle des autorisations ci-dessous.',
  role_management_reset_failed: 'Échec de la réinitialisation des autorisations.',
  role_management_reset_failed_desc: 'Veuillez réessayer dans quelques instants.',
  role_management_switch_role_title: 'Abandonner les modifications ?',
  role_management_switch_role_description: 'Des modifications d’autorisations ne sont pas enregistrées. Changer de rôle les abandonnera. Voulez-vous continuer ?',
  role_management_switch_role_confirm: 'Changer de rôle',
  role_management_created: 'Rôle personnalisé créé avec succès !',
  role_management_created_desc: 'Consultez-le dans le contrôle des autorisations ci-dessous.',
  role_management_permissions_failed: 'Échec du chargement des autorisations.',
  role_management_create_failed: 'Échec de la création du rôle.',
  role_management_create_required: 'Saisissez un nom de rôle et sélectionnez un jeu d’autorisations.',
  role_management_create_failed_desc: 'Veuillez réessayer dans un instant.',
  role_management_create_duplicate: 'Ce nom de rôle existe déjà !',
  role_management_create_duplicate_desc: 'Veuillez saisir un autre nom de rôle et réessayer.',
  role_management_save_success: 'Autorisations du rôle mises à jour avec succès !',
  role_management_save_success_desc: 'Les modifications ont été enregistrées. Vous pouvez les consulter dans le contrôle des autorisations ci-dessous.',
  role_management_save_failed: 'Échec de l’enregistrement des modifications du rôle.',
  role_management_save_failed_desc: 'Veuillez réessayer dans un instant.',
  role_management_permission: 'Fonction',
  role_management_view: 'Afficher',
  role_management_edit: 'Modifier',
  role_management_approve: 'Approuver',
  role_management_search: 'Rechercher des rôles',
  role_management_current_role_prefix: 'Votre rôle actuel est',
  role_management_create: 'Créer un rôle personnalisé',
  role_management_save_changes: 'Enregistrer les modifications',
  common_apply: 'Appliquer',
  role_management_reset_title: 'Réinitialiser les autorisations par défaut ?',
  role_management_reset_tooltip: 'Réinitialiser les autorisations selon la configuration de [{{parentRole}}].',
  role_management_reset_description: 'Les autorisations du rôle seront réinitialisées à la configuration par défaut et toutes les modifications manuelles seront supprimées. Cette action est irréversible.',
  cancel_create_role_title: 'Annuler la création du rôle personnalisé ?',
  cancel_create_role_confirm: 'Annuler la création du rôle',
  cancel_create_role_description: 'Vous avez saisi des informations dans le formulaire. L’annulation supprimera toutes les informations non enregistrées. Voulez-vous continuer ?',
  role_management_delete_title: 'Supprimer le rôle personnalisé ?',
  role_management_delete_preview:
    '{{role}} sera définitivement supprimé. Les utilisateurs auxquels ce rôle est attribué perdront l’accès à toutes les autorisations qui lui sont associées. Voulez-vous continuer ?',
  role_management_delete_failed: 'Échec de la suppression du rôle.',
  role_management_default_role: 'le rôle par défaut',
  role_management_delete_preview_no_users: 'Le rôle personnalisé « {{role}} » sera définitivement supprimé. Voulez-vous continuer ?',
  role_management_create_title: 'Créer un rôle personnalisé',
  role_management_role_name: 'Nom du rôle',
  role_management_permission_set: 'Définir des autorisations personnalisées à partir de',
  role_management_role_name_placeholder: 'Saisissez le nom du rôle',
  role_management_permission_set_placeholder: 'Sélectionnez un rôle de base',
  role_management_reset_success: 'Autorisations réinitialisées avec succès !',
  role_management_reset_success_desc: 'Les autorisations de ce rôle ont été réinitialisées à la configuration par défaut. Vous pouvez les consulter dans le contrôle des autorisations ci-dessous.',
  role_management_reset_failed: 'Échec de la réinitialisation des autorisations.',
  role_management_reset_failed_desc: 'Veuillez réessayer dans un instant.',
};
